import { Th, Flex, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import { AiOutlineArrowUp } from "react-icons/ai";

export const UsageTh = ({ text, isRecebimentoMateriais, newerOrOlder, setNewerOrOlder }) => {
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPulse(false);
    }, 200);

    return () => clearTimeout(timer);
  }, [pulse]);

  return isRecebimentoMateriais ? (
    <Th color="white" textAlign="center" fontSize=".676rem" paddingBlock=".3rem" paddingInline=".2rem" margin="0">
      <Flex w="100%" h="100%" justifyContent="center" alignItems="center">
        <span>{text === "Data Limite de Produção" ? (
          <Text>
            Data Limite <br /> de <br /> Produção
          </Text>
        ) : text}</span>
        <Flex ml="1rem" justifyContent="center" alignItems="center" cursor="pointer">
          <Flex
            transform={newerOrOlder === "newer" ? "rotate(180deg)" : ""}
            transition="all .3s ease-in-out"
            borderRadius="50%"
            padding="0.2rem"
            justifyContent="center"
            alignItems="center"
            border="1px solid white"
            bgColor={pulse ? "white" : "transparent"}
            onClick={() => {
              newerOrOlder === "newer" ? setNewerOrOlder("older") : setNewerOrOlder("newer");
              setPulse(!pulse);
            }}
          >
            {" "}
            <AiOutlineArrowUp size="1rem" />
          </Flex>
        </Flex>
      </Flex>
    </Th>
  ) : (
    <Th color="white" textAlign="center" fontSize=".676rem" paddingBlock=".3rem" paddingInline=".2rem" margin="0">
      {text}
    </Th>
  );
};
